const getPosition: GetPosition = (position, canvas) => {
    const canvasPosition = canvas.getBoundingClientRect();

    return {
        x: position.x - canvasPosition.left,
        y: position.y - canvasPosition.top
    }
}
export default getPosition;